<template>
  <div class="qyjs_box">

   <div>
	 <router-view></router-view>
   </div>
    <div class="box">
		<!-- <div style="background-color: #fff;border-radius: 10px;padding: 20px;margin-bottom: 20px;font-size: 16px;font-weight: bold;margin-top: 20px;">一分一段</div> -->
		<div class="boxA" :class="{ sticky: isSticky }">
			<!-- <div class="box-tit"><span>一分一段</span></div> -->
			<div class="box-tit" ><span v-for="(item,index) in navData" :class="navDataIndex==item.id?'onsele':''" @click="navClick(item)">{{item.courseName}}</span></div>
			<!-- <div class="search-t">
				<el-input  placeholder="请输入院校名称" v-model="queryParams.schoolName"  class="input-with-select" clearable>
					<el-button type="danger" slot="append" icon="el-icon-search" @click="schGet">搜索</el-button>
				</el-input>
			</div> -->
		</div>
		
		
		<div class="schmain">
			 <!-- v-if="schList&&schList.length" v-intersect="handleIntersect"-->
			<div class="sch-ul" v-if="schList&&schList.length"  ref="scrollContainer" v-intersect="handleIntersect">
				<div class="sch-li" v-for="(item,index) in schList" @click="goInfo(item)">
					<div class="schli-l">
						<img :src="UPLODE_URL+item.courseBanner" alt="" />
						<div class="pay">	
							<i class="el-icon-video-play" style="font-size: 30px;color: #fff;display: flex;align-items: center;"></i>
						</div>
					</div>
					<div class="schli-r">
						<div class="schli-rt">
							<span class="schli-rt-a">{{item.courseName}}</span>
							<!-- <span class="schli-rt-b">{{item.schoolCityOne}}·{{item.schoolCityTwo}}</span> -->
							<!-- <span class="t-con-2" style="color: #505559;font-size: 12px;margin-left: 10px;" v-if="item.zuoyueJihua!=0||item.oneJihua==1||item.youJihua==1">{{item.oneJihua!=0?'101计划 | ':''}}  {{item.zuoyueJihua==1?'卓越工程师 | ':''}}  {{item.youJihua==1?'国优计划':''}}</span> -->
						</div>
						<!-- <div class="schli-rb">
							<span v-if="item.natureName">{{item.natureName}}</span>
							<span v-if="item.schoolType">{{item.schoolType}}</span>
							<span v-if="item.schoolLevel">{{item.schoolLevel}}</span>
							<span v-if="item.attribute">{{item.attribute}}</span>
							<span v-if="item.unit">{{item.unit}}</span>
							<span v-if="item.oneJihua!=0">{{item.oneJihua!=0?'101计划':''}}</span>
							<span v-if="item.zuoyueJihua==1">{{item.zuoyueJihua==1?'卓越工程师':''}}</span>
							<span v-if="item.youJihua==1">{{item.youJihua==1?'国优计划':''}}</span>
						</div> -->
					</div>
				</div>
			</div>
			<el-empty v-else :image-size="200"></el-empty>
		</div>
		
		
		
		
	</div>
	<div ref="loadMoreTrigger" style="height: 100px;"></div>
    
  </div>
</template>

<script>
import { xuemengintro } from "@/api/intoxuemeng";
	import  {UPLODE_URL} from '@/utils/request'
	import { EventBus } from '@/utils/event-bus.js';
export default {
  data() {
    return {
		UPLODE_URL,
		batchName:'',
      filtrate: {
      	A: [],//nianfen 
      	B: ['公办', '民办', '独立学院', '中外合作办学', '内地与港澳台地区合作办学', '境外高校独立办学'],//办学性质
      	C: ['985', '211', '研究生院', '双一流', '保研', '双高高职', '示范高职', '骨干高职'],//院校层次
      	D: [],//标签
      	E: [{ id: 1, name: '冲', num: 0 }, { id: 2, name: '稳', num: 0 }, { id: 3, name: '保', num: 0 }, { id: 4, name: '新增' }],
		F:[],
		G: ['是'],
		H: [{name:'101计划',id:'是',quer:'oneJihuas'},{name:'卓越工程师',id:'是',quer:'zuoyueJihuas'},{name:'国优计划',id:'是',quer:'youJihuas'}],
		// {name:'武书连',id:'是',quer:'wushulian'},
		J: [{name:'软科综合',id:'是',quer:'ruanke'},{name:'校友会综合',id:'是',quer:'xiaoyouhui'},{name:'QS',id:'是',quer:'QS'},{name:'US',id:'是',quer:'US'}],
      },
	  schList:[],
	  pageTotal:0,
	  busy: true,

	  // 查询参数
	  queryParams: {
	  	pageNum: 1,
	  	pageSize: 10,
		
	  	schoolName: '',//学校名
	  	schoolLevel:'',//本科和专科
	  	citySchoolIds: [],//省份id 下拉选择传
	  	majorCodeAlls: [],// //专业id 下拉选择传
	  	// majorNames: '', //专业名
	  	schoolType: '', //院校类型
	  	natureName: [], //办学性质
	  	attribute: [], //院校层次
	  	notTtile: [] ,//标签
	  	schoolCityOne:[],
	  	
	  	oneJihuas:'',
	  	zuoyueJihuas:'',
	  	youJihuas:'',
	  	
	  	ruanke:'',
	  	xiaoyouhui:'',
	  	// wushulian:'',
	  	qs:'',
	  	us:'',
		
		
		
	  },
	  navData:[],
	  navDataIndex:0,
	  
	  courseTypeId:'',
	  name:'',
	  token: localStorage.getItem('token')||'',
	  user:JSON.parse(localStorage.getItem('user'))||'',
	  pageNum: 1,
	  
	  isSticky: false,
	  stickyOffset: 20,
    };
  },
  directives: {
      intersect: {
        bind(el, binding) {
          const observer = new IntersectionObserver((entries, observer) => {
			  console.log('entries',entries)
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const img = entry.target;
				console.log('2222sdfsfs',img)
                // 在这里可以做图片的懒加载处理，比如更改src属性
                // img.src = img.dataset.src;
                // 或者触发其他的方法
                // binding.value(entry, observer);
                // observer.unobserve(img); // 停止观察
				// this.createObserver();
              }
            });
          });
   
          observer.observe(el);
        }
      }
    },
  created() {
	// this.getList() //列表数据
	this.courseTypeId = this.$route.query.id
	this.name = this.$route.query.name
	this.getType()
	
  },
  mounted() {
  	 
	 // console.log('this.$route.query',this.$route.query)
	 // this.courseTypeId = this.$route.query.id
	 // this.name = this.$route.query.name
	 // this.getType()
	 this.token= localStorage.getItem('token')||''
	 this.user=JSON.parse(localStorage.getItem('user'))||''
	 this.createObserver();
	 window.addEventListener('scroll', this.handleScroll);
	 // 监听退出登录事件
	 // window.addEventListener('storage', this.handleLogout);
  },
  
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(vm.$route.query); // 正确使用 vm 访问组件实例
	  vm.courseTypeId = vm.$route.query.id
	  vm.name = vm.$route.query.name
	  vm.getType()
    });
  },
 beforeDestroy() {
 	  window.removeEventListener('scroll', this.handleScroll);
	  // 监听退出登录事件
	  // window.addEventListener('storage', this.handleLogout);
   },
  methods: {
	
	  handleScroll() {
	        this.isSticky = window.scrollY >= this.stickyOffset;
	  			console.log('this.isSticky',this.isSticky)
	    },
	  getType(){
		  let qu={
			  courseTypeId:this.courseTypeId
		  }
		this.api.courseTypeListOneApi(qu).then(res => {
			this.navData = res.data
			 this.navDataIndex = res.data[0].id
			this.getList()
		})
	  },
	  navClick(item){
	  		this.navDataIndex=item.id
			this.getList()
	  		this.$forceUpdate()
	  },
	  // 跳转学校详情
	  goInfo(item){
		  if(this.user.userVip==0){
			  EventBus.$emit('vipOpen');
			  return
		  }
		 localStorage.setItem('videoInfo',JSON.stringify(item))
		  this.$router.push({path:'/Ainformation/videoInfo'})
		  return
		  
		const route =this.$router.resolve({name:'videoInfo',})
		localStorage.setItem('videoInfo',JSON.stringify(item))
		// 打开新窗口并导航至生成的URL
		window.open(route.href, '_blank');
	  },
	  handleIntersect(entry, observer){
		  console.log('11111111111111111111fff')
		  if (this.pageNum >= this.pageTotal ) {
		  	// this.$message({
		  	//   message: '没有更多了',
		  	//   type: 'warning',
		  	//   duration: '4000'
		  	// });
		  	return
		  }
		  // this.busy = true
		  this.pageNum++;
		  this.getList('more')
	  },
	  createObserver() {
	        const options = {
	          root: null, // viewport
	          rootMargin: '100px',
	          threshold: 1.0
	        };
	        const observer = new IntersectionObserver(this.handleIntersect, options);
	        observer.observe(this.$refs.loadMoreTrigger);
	      },
	  creat(){
		  
	  },
	  
	   
	   
	   // 数据列表请求
	   getList(type){
		   let qu={
		   		courseTypeId:this.courseTypeId,
				pageNum: this.pageNum,
				pageSize: 10,
				pid: this.navDataIndex,
		   }
		    this.api.courseListApi(qu).then(res => {
				if(res.code==200){
					
					if (type == 'more') {
						if (!res.data) {
							this.$message({
								message: '没有更多了',
								type: 'warning',
								duration: '4000'
							});
							return
						}
						this.schList = [...this.schList, ...res.data.rows];
						
					}else{
						this.schList = []
						this.schList = res.data ? res.data.rows : [];
						// this.dataText = res.data ? '' : '暂无数据'; //进去页面先让字样为空
						this.pageTotal = res.data ? res.data.pageTotal : 0;
					}
					
					
					// if(res.data&&res.data.rows){
					// 	this.pageTotal = res.data.pageTotal
					// 	this.schList = res.data.rows;
						
					// 	// this.schList = [...this.schList, ...res.data.rows];
						
					// }else{
					// 	this.schList = []
					// }
				}else{
					 this.$message.error(res.msg);
				}
			})
	   }
  },
};
</script>

<style lang="scss" scoped>
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.box{
	/deep/.el-form-item__content{
		flex: 1;
	}
	.el-form-item--small.el-form-item {
		margin-bottom: 5px;
	}
	// height: 100vh;
	// min-height: 30vh;
	.boxA{
		    border-radius: 10px;
		    padding: 0px 0px 0px 0px;
		    /* margin-top: 10px; */
		    margin: 20px 10px 10px 10px;
		// .box-tit{
		// 	width: 100%;
		// 	height: 40px;
		// 	line-height: 40px;
		// 	border-bottom: 1px solid #F44F4D;
		// 	margin-bottom: 15px;
		// 	span{
		// 		width: 140px;
		// 		height: 40px;
		// 		line-height: 40px;
		// 		background-color: #F44F4D;
		// 		color: #fff;
		// 		display: block;
		// 		border-radius: 10px 10px 0 0;
		// 		text-align: center;
		// 		font-size: 15px;
		// 	}
		// }
		.box-tit{
			width: 100%;
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #F44F4D;
			display: flex;
			span{
				width: 140px;
				height: 40px;
				line-height: 40px;
				cursor: pointer;
				display: block;
				text-align: center;
				font-size: 15px;
			}
			span.onsele{
				background-color: #F44F4D;
				color: #fff;
				border-radius: 10px 10px 0 0;
				font-size: 15px;
			}
		}
		
		.search-t{
			width: 30%;
			margin-bottom: 10px;
			.input-with-select{
				border-radius: 4px;
				/deep/.el-input__inner{
					border-color: #F56C6C!important;
				}
				/deep/.el-button--danger{
					border: none!important;
				}
				/deep/.el-button{
					border: 1px solid #f44f4d!important;
					background: #f44f4d;
					color: #fff;
					border-radius: 0  4px 4px 0px;
				}
			}
		}
		
		.topsec{
			
			.kuai{
				display: flex;
				flex-wrap: wrap;
				span{
					margin-right: 20px;
					cursor: pointer;
				}
				span.onsele{
					color: #F44F4D;
				}
			}
			.el-form-item {
				display: flex;
			}
		}
	}
	
	// <div class="schmain">
	// 	<div class="sch-ul">
	// 		<div class="sch-li">
	// 			<div class="schli-l"><img src="../../assets/1.png" alt="" /></div>
	// 			<div class="schli-r">
	// 				<div class="schli-rt"><span class="schli-rt-a">天津大学</span><span class="schli-rt-b">dizhi</span></div>
	// 				<div class="schli-rb"><span>benke </span></div>
	// 			</div>
	// 		</div>
	// 	</div>
	// </div>
	.schmain{
		    margin-top: 12px;
		    padding: 10px;
		    border-radius: 10px;
			min-height: 80vh;
		.sch-ul{
			.sch-li:hover{
				.schli-rt-a{
					color: #F44F4D;
				}
			}
			.sch-li{
				
				background: #fff;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				padding: 20px;
				border-radius: 10px;
				cursor: pointer;
				.schli-l{
					width: 120px;
					height: 90px;
					margin-right: 20px;
					position: relative;
					img{
						width: 120px;
						height: 90px;
						border-radius: 10px;
					}
					.pay{
						position: absolute;
						background: rgba(4, 4, 4, 0.3);
						border-radius: 10px;
						left: 0;
						right: 0;
						bottom: 0;
						top: 0;
						display: flex;
						justify-content: center;
					}
				}
				.schli-r{
					flex: 1;
					.schli-rt{
						display: flex;
						align-items: center;
						margin-bottom: 10px;
						.schli-rt-a{
							font-size: 22px;
						}
						.schli-rt-b{
							margin-left: 10px;
							    height: 25px;
								line-height: 25px;
							    border-radius: 26px;
							    border: 1px solid #d8d8d8;
							    padding: 0 10px;
							    font-size: 12px;
							    color: #666;
						}
					}
					.schli-rb{
						margin-top: 6px;
						span{
							    height: 22px;
							    padding: 0 8px;
							    border-radius: 4px;
							    background: #f5f6f7;
							    font-size: 14px;
							    color: #666;
							    margin-right: 8px;
						}
					}
				}
			}
		}
	}
}
.admit-scoreLine-box-table-th{
				margin-bottom: 10px;
			}
			.admit-scoreLine-box-table-list{
				width: 100%;
				display: flex;
				.admit-scoreLine-box-table-list-div{
					flex: 1;
					// margin-bottom: 6px;
					text-align: center;
					line-height: 40px;
					    border-bottom: 1px solid #f0f0f0;
				}
				
			}
.admit-scoreLine-box-table-th-div{
	font-size: 14px;
	text-align: center;
}


.sticky {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1000;
  box-shadow: 3px 5px 15px rgba(0.955, 0.31, 0.303, 0.25);
  .box-tit{
	  height: 50px!important;
	  span{
		  height: 50px!important;
		  line-height: 50px!important;
	  }
  }
}

</style>